import { FeatureFlag } from '../FeatureFlag';

export const enableLabAutoAcceptPercent = new FeatureFlag({
    key: 'enable-lab-auto-accept-percent',
    defaultValue: false,
});
